import { css, styled } from '../../hooks/theme';
import { getCssFont } from '../../styles';
import { Tokens } from '../../types';

interface Props {
  side: 'top' | 'right' | 'down' | 'left';
}

export const TooltipContainer = styled.div<Props>`
  &:first-child {
    position: relative;
    display: inline-block;
    &::after,
    &::before {
      position: absolute;
      z-index: 100;
      opacity: 0;
      ${props => {
        if (props.side == 'top') {
          return css`
            transition: bottom 0.25s ease-in-out;
            bottom: 90%;
            left: -9999px;
            margin-bottom: 12px;
          `;
        }
        if (props.side == 'right') {
          return css`
            transition: left 0.25s ease-in-out;
            top: -9999px;
            left: 96%;
            margin-left: 12px;
          `;
        }
        if (props.side == 'down') {
          return css`
            transition: top 0.25s ease-in-out;
            top: 90%;
            left: -9999px;
            margin-top: 12px;
          `;
        }
        if (props.side == 'left') {
          return css`
            transition: right 0.25s ease-in-out;
            top: -9999px;
            right: 96%;
            margin-right: 12px;
          `;
        }
      }}
    }
    &::after {
      ${props => {
        return css`
          background-color: ${props.theme.colors.brand.secondary[100]};
          font: ${getCssFont(props.theme.font.desktop.paragraph.p2.regular)};
        `;
      }}
      padding: 8px 12px;
      content: attr(aria-label);
      text-align: center;
      color: #fff;
      border-radius: 4px;
      text-shadow: 0 0 5px #000;
      white-space: nowrap;
    }
    &::before {
      content: '';
      //width: 0;
      height: 0;
      border-width: 6px;
      border-style: solid;
      ${props => {
        if (props.side == 'top') {
          return css`
            //top
            border-color: #222 transparent transparent transparent;
            margin-bottom: 0;
          `;
        }
        if (props.side == 'right') {
          return css`
            //right
            border-color: transparent #222 transparent transparent;
            margin-left: 0;
          `;
        }
        if (props.side == 'down') {
          return css`
            //right
            border-color: transparent transparent #222 transparent;
            margin-top: 0;
          `;
        }
        if (props.side == 'left') {
          return css`
            //right
            border-color: transparent transparent transparent #222;
            margin-right: 0;
          `;
        }
      }}
    }
    &:hover::after,
    &:focus::after,
    &:hover::before,
    &:focus::before {
      opacity: 1;
      ${props => {
        if (props.side == 'top') {
          return css`
            bottom: 95%;
            left: 0;
          `;
        }
        if (props.side == 'right') {
          return css`
            left: 95%;
            top: 0;
          `;
        }
        if (props.side == 'down') {
          return css`
            top: 85%;
            left: 0;
          `;
        }
        if (props.side == 'left') {
          return css`
            right: 95%;
            top: 0;
          `;
        }
      }}
    }
    &:hover::before,
    &:focus::before {
      ${props => {
        if (props.side == 'top' || props.side == 'down') {
          return css`
            left: 15px;
          `;
        }
        if (props.side == 'right' || props.side == 'left') {
          return css`
            top: 7px;
          `;
        }
      }}
    }
  }
`;

TooltipContainer.defaultProps = {
  theme: Tokens.eixods,
};
